export default __webpack_public_path__ + "804252529364f56d2ded9c36b00a9c67.png";